/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompetitionEntryType } from './CompetitionEntryType';
import {
    CompetitionEntryTypeFromJSON,
    CompetitionEntryTypeFromJSONTyped,
    CompetitionEntryTypeToJSON,
    CompetitionEntryTypeToJSONTyped,
} from './CompetitionEntryType';
import type { TournamentPlatform } from './TournamentPlatform';
import {
    TournamentPlatformFromJSON,
    TournamentPlatformFromJSONTyped,
    TournamentPlatformToJSON,
    TournamentPlatformToJSONTyped,
} from './TournamentPlatform';
import type { EntryFeeUnit } from './EntryFeeUnit';
import {
    EntryFeeUnitFromJSON,
    EntryFeeUnitFromJSONTyped,
    EntryFeeUnitToJSON,
    EntryFeeUnitToJSONTyped,
} from './EntryFeeUnit';
import type { TournamentPrizeSplit } from './TournamentPrizeSplit';
import {
    TournamentPrizeSplitFromJSON,
    TournamentPrizeSplitFromJSONTyped,
    TournamentPrizeSplitToJSON,
    TournamentPrizeSplitToJSONTyped,
} from './TournamentPrizeSplit';
import type { CompetitionFaq } from './CompetitionFaq';
import {
    CompetitionFaqFromJSON,
    CompetitionFaqFromJSONTyped,
    CompetitionFaqToJSON,
    CompetitionFaqToJSONTyped,
} from './CompetitionFaq';
import type { GlobalFilterExclusion } from './GlobalFilterExclusion';
import {
    GlobalFilterExclusionFromJSON,
    GlobalFilterExclusionFromJSONTyped,
    GlobalFilterExclusionToJSON,
    GlobalFilterExclusionToJSONTyped,
} from './GlobalFilterExclusion';
import type { TournamentCategory } from './TournamentCategory';
import {
    TournamentCategoryFromJSON,
    TournamentCategoryFromJSONTyped,
    TournamentCategoryToJSON,
    TournamentCategoryToJSONTyped,
} from './TournamentCategory';
import type { TournamentRegion } from './TournamentRegion';
import {
    TournamentRegionFromJSON,
    TournamentRegionFromJSONTyped,
    TournamentRegionToJSON,
    TournamentRegionToJSONTyped,
} from './TournamentRegion';
import type { TournamentStatus } from './TournamentStatus';
import {
    TournamentStatusFromJSON,
    TournamentStatusFromJSONTyped,
    TournamentStatusToJSON,
    TournamentStatusToJSONTyped,
} from './TournamentStatus';
import type { TournamentFinalStanding } from './TournamentFinalStanding';
import {
    TournamentFinalStandingFromJSON,
    TournamentFinalStandingFromJSONTyped,
    TournamentFinalStandingToJSON,
    TournamentFinalStandingToJSONTyped,
} from './TournamentFinalStanding';
import type { ChallengeThemeColors } from './ChallengeThemeColors';
import {
    ChallengeThemeColorsFromJSON,
    ChallengeThemeColorsFromJSONTyped,
    ChallengeThemeColorsToJSON,
    ChallengeThemeColorsToJSONTyped,
} from './ChallengeThemeColors';
import type { BracketType } from './BracketType';
import {
    BracketTypeFromJSON,
    BracketTypeFromJSONTyped,
    BracketTypeToJSON,
    BracketTypeToJSONTyped,
} from './BracketType';
import type { TournamentBracket } from './TournamentBracket';
import {
    TournamentBracketFromJSON,
    TournamentBracketFromJSONTyped,
    TournamentBracketToJSON,
    TournamentBracketToJSONTyped,
} from './TournamentBracket';
import type { PrerequisiteResponse } from './PrerequisiteResponse';
import {
    PrerequisiteResponseFromJSON,
    PrerequisiteResponseFromJSONTyped,
    PrerequisiteResponseToJSON,
    PrerequisiteResponseToJSONTyped,
} from './PrerequisiteResponse';
import type { TournamentFeeMode } from './TournamentFeeMode';
import {
    TournamentFeeModeFromJSON,
    TournamentFeeModeFromJSONTyped,
    TournamentFeeModeToJSON,
    TournamentFeeModeToJSONTyped,
} from './TournamentFeeMode';
import type { EntryFeeConfigResponse } from './EntryFeeConfigResponse';
import {
    EntryFeeConfigResponseFromJSON,
    EntryFeeConfigResponseFromJSONTyped,
    EntryFeeConfigResponseToJSON,
    EntryFeeConfigResponseToJSONTyped,
} from './EntryFeeConfigResponse';
import type { TournamentAdvancementRules } from './TournamentAdvancementRules';
import {
    TournamentAdvancementRulesFromJSON,
    TournamentAdvancementRulesFromJSONTyped,
    TournamentAdvancementRulesToJSON,
    TournamentAdvancementRulesToJSONTyped,
} from './TournamentAdvancementRules';
import type { TournamentCurrency } from './TournamentCurrency';
import {
    TournamentCurrencyFromJSON,
    TournamentCurrencyFromJSONTyped,
    TournamentCurrencyToJSON,
    TournamentCurrencyToJSONTyped,
} from './TournamentCurrency';
import type { MatchResponse } from './MatchResponse';
import {
    MatchResponseFromJSON,
    MatchResponseFromJSONTyped,
    MatchResponseToJSON,
    MatchResponseToJSONTyped,
} from './MatchResponse';
import type { TournamentPrivacy } from './TournamentPrivacy';
import {
    TournamentPrivacyFromJSON,
    TournamentPrivacyFromJSONTyped,
    TournamentPrivacyToJSON,
    TournamentPrivacyToJSONTyped,
} from './TournamentPrivacy';
import type { TournamentPrizePool } from './TournamentPrizePool';
import {
    TournamentPrizePoolFromJSON,
    TournamentPrizePoolFromJSONTyped,
    TournamentPrizePoolToJSON,
    TournamentPrizePoolToJSONTyped,
} from './TournamentPrizePool';
import type { TournamentTeamSummary } from './TournamentTeamSummary';
import {
    TournamentTeamSummaryFromJSON,
    TournamentTeamSummaryFromJSONTyped,
    TournamentTeamSummaryToJSON,
    TournamentTeamSummaryToJSONTyped,
} from './TournamentTeamSummary';
import type { TournamentSkillLevel } from './TournamentSkillLevel';
import {
    TournamentSkillLevelFromJSON,
    TournamentSkillLevelFromJSONTyped,
    TournamentSkillLevelToJSON,
    TournamentSkillLevelToJSONTyped,
} from './TournamentSkillLevel';

/**
 * Detailed tournament view with teams and matches. Contains all fields from TournamentResponse plus teams, matches, and userTeamId.
 * @export
 * @interface TournamentDetailResponse
 */
export interface TournamentDetailResponse {
    /**
     * Tournament ID
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    challengeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    rules?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    gameId?: string;
    /**
     * 
     * @type {BracketType}
     * @memberof TournamentDetailResponse
     */
    bracketType: BracketType;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    teamSize: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    maxTeams: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    minTeams: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    registrationOpens?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    registrationCloses?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    startTime?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    endTime?: number;
    /**
     * 
     * @type {TournamentStatus}
     * @memberof TournamentDetailResponse
     */
    status: TournamentStatus;
    /**
     * 
     * @type {CompetitionEntryType}
     * @memberof TournamentDetailResponse
     */
    entryType?: CompetitionEntryType;
    /**
     * 
     * @type {EntryFeeConfigResponse}
     * @memberof TournamentDetailResponse
     */
    entryFeeConfig?: EntryFeeConfigResponse;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    entryFee: number;
    /**
     * 
     * @type {TournamentCurrency}
     * @memberof TournamentDetailResponse
     */
    entryFeeCurrency?: TournamentCurrency;
    /**
     * 
     * @type {EntryFeeUnit}
     * @memberof TournamentDetailResponse
     */
    entryFeeUnit?: EntryFeeUnit;
    /**
     * 
     * @type {TournamentFeeMode}
     * @memberof TournamentDetailResponse
     */
    feeMode?: TournamentFeeMode;
    /**
     * Fee modes a captain may choose from at registration. Empty means no choice is offered and feeMode applies to every team.
     * @type {Array<TournamentFeeMode>}
     * @memberof TournamentDetailResponse
     */
    allowedFeeModes?: Array<TournamentFeeMode>;
    /**
     * 
     * @type {TournamentPrizeSplit}
     * @memberof TournamentDetailResponse
     */
    prizeSplit?: TournamentPrizeSplit;
    /**
     * 
     * @type {TournamentPrizePool}
     * @memberof TournamentDetailResponse
     */
    prizePool?: TournamentPrizePool;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    payoutTableId?: string;
    /**
     * Prizes only pay out if at least this many competed. Distinct from minTeams, which gates whether the tournament can start. Below this count distribution is refused, not auto-refunded — cancel the tournament to refund entrants.
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    minParticipants?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    collectedPrizePool?: number;
    /**
     * 
     * @type {TournamentBracket}
     * @memberof TournamentDetailResponse
     */
    bracket?: TournamentBracket;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentDetailResponse
     */
    registeredTeams: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    registeredTeamsCount: number;
    /**
     * 
     * @type {Array<TournamentFinalStanding>}
     * @memberof TournamentDetailResponse
     */
    finalStandings?: Array<TournamentFinalStanding>;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    sponsorId?: string;
    /**
     * Sponsor brand palette, resolved from the sponsor's Hub themeColors (falls back to the Brand's signature colour). Display-only; drives the tournament surface theme.
     * @type {ChallengeThemeColors}
     * @memberof TournamentDetailResponse
     */
    sponsorThemeColors?: ChallengeThemeColors;
    /**
     * 
     * @type {TournamentPlatform}
     * @memberof TournamentDetailResponse
     */
    platform?: TournamentPlatform;
    /**
     * 
     * @type {TournamentRegion}
     * @memberof TournamentDetailResponse
     */
    region?: TournamentRegion;
    /**
     * 
     * @type {TournamentPrivacy}
     * @memberof TournamentDetailResponse
     */
    privacy?: TournamentPrivacy;
    /**
     * 
     * @type {TournamentSkillLevel}
     * @memberof TournamentDetailResponse
     */
    skillLevel?: TournamentSkillLevel;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    ageRestriction?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    checkInRequired?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    checkInWindowMinutes?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    streamUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    discordUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    contactEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    imageUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    chatChannelId?: string;
    /**
     * 
     * @type {TournamentCategory}
     * @memberof TournamentDetailResponse
     */
    category?: TournamentCategory;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    rosterLocked?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    rosterLockedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    rosterLockedBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    hasPassword?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    bestOf?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    isRecurring?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    recurringSchedule?: string;
    /**
     * IANA timezone the recurringSchedule's time is interpreted in (default UTC)
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    recurringTimezone?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    parentTournamentId?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    recurringInstanceNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    competitionId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    ruleSetId?: string;
    /**
     * 
     * @type {TournamentAdvancementRules}
     * @memberof TournamentDetailResponse
     */
    advancementRules?: TournamentAdvancementRules;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    clanTagRequired?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    clanTagFormat?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    matchModeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    subModeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    scoringTemplateId?: string;
    /**
     * How match scores are collected. MANUAL = captain submit/confirm; EVENT_PIPELINE = auto from Overwolf events; HYBRID = auto-tracked, human confirms.
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    scoringMode?: TournamentDetailResponseScoringModeEnum;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    bracketTemplateId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    sharedBracketId?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    lateRegistrationMinutes?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    featured?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    featuredUntil?: number;
    /**
     * Derived from prizePool.guaranteedPoolUsd — true when Devour has committed a funded base. Not writable; set guaranteedPoolUsd instead.
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    readonly guaranteedPrize?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    skipConsolationRound?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    skipGrandFinalComeback?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    skipSecondaryFinal?: boolean;
    /**
     * Override default place labels keyed by placement number (e.g. "1" → "Grand Champion")
     * @type {{ [key: string]: string; }}
     * @memberof TournamentDetailResponse
     */
    customPrizeLabels?: { [key: string]: string; };
    /**
     * 
     * @type {Array<TournamentPlatform>}
     * @memberof TournamentDetailResponse
     */
    platforms?: Array<TournamentPlatform>;
    /**
     * 
     * @type {Array<TournamentRegion>}
     * @memberof TournamentDetailResponse
     */
    regions?: Array<TournamentRegion>;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    antiCheat?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    eligibility?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    ruleset?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    rulesUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    platformNotes?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    cancelledAt?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    cancelledBy?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    cancellationReason?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    archivedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    archivedBy?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    emergencyFrozen?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    emergencyFrozenAt?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    emergencyFrozenBy?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    emergencyFreezeReason?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    autoStartEnabled?: boolean;
    /**
     * 
     * @type {Array<CompetitionFaq>}
     * @memberof TournamentDetailResponse
     */
    faqs?: Array<CompetitionFaq>;
    /**
     * 
     * @type {Array<PrerequisiteResponse>}
     * @memberof TournamentDetailResponse
     */
    prerequisites: Array<PrerequisiteResponse>;
    /**
     * IDs of EventPipelineFilter documents applied to this tournament's events. Layered on top of the game-wide global filter; blocks when any assigned filter votes BLOCK (conditions AND-compose within each filter; exclude conditions block on match, include conditions block on non-match).
     * @type {Array<string>}
     * @memberof TournamentDetailResponse
     */
    appliedFilterIds?: Array<string>;
    /**
     * Break-glass per-entity exclusions of GLOBAL filters for this tournament (PRODUCT_PLAN D2(b)). Each entry names one global filter this tournament opts out of, with a required reason and a required absolute expiry. Evaluated as set membership against the blocking-filter ids stamped on the fan-out message; expiry is enforced at read.
     * @type {Array<GlobalFilterExclusion>}
     * @memberof TournamentDetailResponse
     */
    excludedGlobalFilters?: Array<GlobalFilterExclusion>;
    /**
     * Rule 4 opt-out. When true this tournament still scores events whose match context is missing (the pre-Rule-4 behavior). Default false — a tournament that declares what counts should not score events that cannot prove they qualify.
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    failOpenOnMissingContext?: boolean;
    /**
     * Cheat-filtering match-bracketing gate — requires active Match Start / Round Start in Redis to score
     * @type {boolean}
     * @memberof TournamentDetailResponse
     */
    requireActiveMatch?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentDetailResponse
     */
    updatedAt: number;
    /**
     * Teams registered for this tournament
     * @type {Array<TournamentTeamSummary>}
     * @memberof TournamentDetailResponse
     */
    teams?: Array<TournamentTeamSummary>;
    /**
     * One row per playable match — the shared MatchModel reporting docs (one per bracket match, seeded at tournament start).
     * @type {Array<MatchResponse>}
     * @memberof TournamentDetailResponse
     */
    matches?: Array<MatchResponse>;
    /**
     * ID of the authenticated user's team (if any)
     * @type {string}
     * @memberof TournamentDetailResponse
     */
    userTeamId?: string;
}


/**
 * @export
 */
export const TournamentDetailResponseScoringModeEnum = {
    MANUAL: 'MANUAL',
    EVENT_PIPELINE: 'EVENT_PIPELINE',
    HYBRID: 'HYBRID'
} as const;
export type TournamentDetailResponseScoringModeEnum = typeof TournamentDetailResponseScoringModeEnum[keyof typeof TournamentDetailResponseScoringModeEnum];


/**
 * Check if a given object implements the TournamentDetailResponse interface.
 */
export function instanceOfTournamentDetailResponse(value: object): value is TournamentDetailResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('bracketType' in value) || value['bracketType'] === undefined) return false;
    if (!('teamSize' in value) || value['teamSize'] === undefined) return false;
    if (!('maxTeams' in value) || value['maxTeams'] === undefined) return false;
    if (!('minTeams' in value) || value['minTeams'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('entryFee' in value) || value['entryFee'] === undefined) return false;
    if (!('registeredTeams' in value) || value['registeredTeams'] === undefined) return false;
    if (!('registeredTeamsCount' in value) || value['registeredTeamsCount'] === undefined) return false;
    if (!('prerequisites' in value) || value['prerequisites'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function TournamentDetailResponseFromJSON(json: any): TournamentDetailResponse {
    return TournamentDetailResponseFromJSONTyped(json, false);
}

export function TournamentDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'challengeId': json['challengeId'] == null ? undefined : json['challengeId'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'rules': json['rules'] == null ? undefined : json['rules'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'bracketType': BracketTypeFromJSON(json['bracketType']),
        'teamSize': json['teamSize'],
        'maxTeams': json['maxTeams'],
        'minTeams': json['minTeams'],
        'registrationOpens': json['registrationOpens'] == null ? undefined : json['registrationOpens'],
        'registrationCloses': json['registrationCloses'] == null ? undefined : json['registrationCloses'],
        'startTime': json['startTime'] == null ? undefined : json['startTime'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'status': TournamentStatusFromJSON(json['status']),
        'entryType': json['entryType'] == null ? undefined : CompetitionEntryTypeFromJSON(json['entryType']),
        'entryFeeConfig': json['entryFeeConfig'] == null ? undefined : EntryFeeConfigResponseFromJSON(json['entryFeeConfig']),
        'entryFee': json['entryFee'],
        'entryFeeCurrency': json['entryFeeCurrency'] == null ? undefined : TournamentCurrencyFromJSON(json['entryFeeCurrency']),
        'entryFeeUnit': json['entryFeeUnit'] == null ? undefined : EntryFeeUnitFromJSON(json['entryFeeUnit']),
        'feeMode': json['feeMode'] == null ? undefined : TournamentFeeModeFromJSON(json['feeMode']),
        'allowedFeeModes': json['allowedFeeModes'] == null ? undefined : ((json['allowedFeeModes'] as Array<any>).map(TournamentFeeModeFromJSON)),
        'prizeSplit': json['prizeSplit'] == null ? undefined : TournamentPrizeSplitFromJSON(json['prizeSplit']),
        'prizePool': json['prizePool'] == null ? undefined : TournamentPrizePoolFromJSON(json['prizePool']),
        'payoutTableId': json['payoutTableId'] == null ? undefined : json['payoutTableId'],
        'minParticipants': json['minParticipants'] == null ? undefined : json['minParticipants'],
        'collectedPrizePool': json['collectedPrizePool'] == null ? undefined : json['collectedPrizePool'],
        'bracket': json['bracket'] == null ? undefined : TournamentBracketFromJSON(json['bracket']),
        'registeredTeams': json['registeredTeams'],
        'registeredTeamsCount': json['registeredTeamsCount'],
        'finalStandings': json['finalStandings'] == null ? undefined : ((json['finalStandings'] as Array<any>).map(TournamentFinalStandingFromJSON)),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'sponsorId': json['sponsorId'] == null ? undefined : json['sponsorId'],
        'sponsorThemeColors': json['sponsorThemeColors'] == null ? undefined : ChallengeThemeColorsFromJSON(json['sponsorThemeColors']),
        'platform': json['platform'] == null ? undefined : TournamentPlatformFromJSON(json['platform']),
        'region': json['region'] == null ? undefined : TournamentRegionFromJSON(json['region']),
        'privacy': json['privacy'] == null ? undefined : TournamentPrivacyFromJSON(json['privacy']),
        'skillLevel': json['skillLevel'] == null ? undefined : TournamentSkillLevelFromJSON(json['skillLevel']),
        'ageRestriction': json['ageRestriction'] == null ? undefined : json['ageRestriction'],
        'checkInRequired': json['checkInRequired'] == null ? undefined : json['checkInRequired'],
        'checkInWindowMinutes': json['checkInWindowMinutes'] == null ? undefined : json['checkInWindowMinutes'],
        'streamUrl': json['streamUrl'] == null ? undefined : json['streamUrl'],
        'discordUrl': json['discordUrl'] == null ? undefined : json['discordUrl'],
        'contactEmail': json['contactEmail'] == null ? undefined : json['contactEmail'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'chatChannelId': json['chatChannelId'] == null ? undefined : json['chatChannelId'],
        'category': json['category'] == null ? undefined : TournamentCategoryFromJSON(json['category']),
        'rosterLocked': json['rosterLocked'] == null ? undefined : json['rosterLocked'],
        'rosterLockedAt': json['rosterLockedAt'] == null ? undefined : json['rosterLockedAt'],
        'rosterLockedBy': json['rosterLockedBy'] == null ? undefined : json['rosterLockedBy'],
        'hasPassword': json['hasPassword'] == null ? undefined : json['hasPassword'],
        'bestOf': json['bestOf'] == null ? undefined : json['bestOf'],
        'isRecurring': json['isRecurring'] == null ? undefined : json['isRecurring'],
        'recurringSchedule': json['recurringSchedule'] == null ? undefined : json['recurringSchedule'],
        'recurringTimezone': json['recurringTimezone'] == null ? undefined : json['recurringTimezone'],
        'parentTournamentId': json['parentTournamentId'] == null ? undefined : json['parentTournamentId'],
        'recurringInstanceNumber': json['recurringInstanceNumber'] == null ? undefined : json['recurringInstanceNumber'],
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'ruleSetId': json['ruleSetId'] == null ? undefined : json['ruleSetId'],
        'advancementRules': json['advancementRules'] == null ? undefined : TournamentAdvancementRulesFromJSON(json['advancementRules']),
        'clanTagRequired': json['clanTagRequired'] == null ? undefined : json['clanTagRequired'],
        'clanTagFormat': json['clanTagFormat'] == null ? undefined : json['clanTagFormat'],
        'matchModeId': json['matchModeId'] == null ? undefined : json['matchModeId'],
        'subModeId': json['subModeId'] == null ? undefined : json['subModeId'],
        'scoringTemplateId': json['scoringTemplateId'] == null ? undefined : json['scoringTemplateId'],
        'scoringMode': json['scoringMode'] == null ? undefined : json['scoringMode'],
        'bracketTemplateId': json['bracketTemplateId'] == null ? undefined : json['bracketTemplateId'],
        'sharedBracketId': json['sharedBracketId'] == null ? undefined : json['sharedBracketId'],
        'lateRegistrationMinutes': json['lateRegistrationMinutes'] == null ? undefined : json['lateRegistrationMinutes'],
        'featured': json['featured'] == null ? undefined : json['featured'],
        'featuredUntil': json['featuredUntil'] == null ? undefined : json['featuredUntil'],
        'guaranteedPrize': json['guaranteedPrize'] == null ? undefined : json['guaranteedPrize'],
        'skipConsolationRound': json['skipConsolationRound'] == null ? undefined : json['skipConsolationRound'],
        'skipGrandFinalComeback': json['skipGrandFinalComeback'] == null ? undefined : json['skipGrandFinalComeback'],
        'skipSecondaryFinal': json['skipSecondaryFinal'] == null ? undefined : json['skipSecondaryFinal'],
        'customPrizeLabels': json['customPrizeLabels'] == null ? undefined : json['customPrizeLabels'],
        'platforms': json['platforms'] == null ? undefined : ((json['platforms'] as Array<any>).map(TournamentPlatformFromJSON)),
        'regions': json['regions'] == null ? undefined : ((json['regions'] as Array<any>).map(TournamentRegionFromJSON)),
        'antiCheat': json['antiCheat'] == null ? undefined : json['antiCheat'],
        'eligibility': json['eligibility'] == null ? undefined : json['eligibility'],
        'ruleset': json['ruleset'] == null ? undefined : json['ruleset'],
        'rulesUrl': json['rulesUrl'] == null ? undefined : json['rulesUrl'],
        'platformNotes': json['platformNotes'] == null ? undefined : json['platformNotes'],
        'cancelledAt': json['cancelledAt'] == null ? undefined : json['cancelledAt'],
        'cancelledBy': json['cancelledBy'] == null ? undefined : json['cancelledBy'],
        'cancellationReason': json['cancellationReason'] == null ? undefined : json['cancellationReason'],
        'archivedAt': json['archivedAt'] == null ? undefined : json['archivedAt'],
        'archivedBy': json['archivedBy'] == null ? undefined : json['archivedBy'],
        'emergencyFrozen': json['emergencyFrozen'] == null ? undefined : json['emergencyFrozen'],
        'emergencyFrozenAt': json['emergencyFrozenAt'] == null ? undefined : json['emergencyFrozenAt'],
        'emergencyFrozenBy': json['emergencyFrozenBy'] == null ? undefined : json['emergencyFrozenBy'],
        'emergencyFreezeReason': json['emergencyFreezeReason'] == null ? undefined : json['emergencyFreezeReason'],
        'autoStartEnabled': json['autoStartEnabled'] == null ? undefined : json['autoStartEnabled'],
        'faqs': json['faqs'] == null ? undefined : ((json['faqs'] as Array<any>).map(CompetitionFaqFromJSON)),
        'prerequisites': ((json['prerequisites'] as Array<any>).map(PrerequisiteResponseFromJSON)),
        'appliedFilterIds': json['appliedFilterIds'] == null ? undefined : json['appliedFilterIds'],
        'excludedGlobalFilters': json['excludedGlobalFilters'] == null ? undefined : ((json['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionFromJSON)),
        'failOpenOnMissingContext': json['failOpenOnMissingContext'] == null ? undefined : json['failOpenOnMissingContext'],
        'requireActiveMatch': json['requireActiveMatch'] == null ? undefined : json['requireActiveMatch'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'teams': json['teams'] == null ? undefined : ((json['teams'] as Array<any>).map(TournamentTeamSummaryFromJSON)),
        'matches': json['matches'] == null ? undefined : ((json['matches'] as Array<any>).map(MatchResponseFromJSON)),
        'userTeamId': json['userTeamId'] == null ? undefined : json['userTeamId'],
    };
}

export function TournamentDetailResponseToJSON(json: any): TournamentDetailResponse {
    return TournamentDetailResponseToJSONTyped(json, false);
}

export function TournamentDetailResponseToJSONTyped(value?: Omit<TournamentDetailResponse, 'guaranteedPrize'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'challengeId': value['challengeId'],
        'name': value['name'],
        'description': value['description'],
        'rules': value['rules'],
        'gameId': value['gameId'],
        'bracketType': BracketTypeToJSON(value['bracketType']),
        'teamSize': value['teamSize'],
        'maxTeams': value['maxTeams'],
        'minTeams': value['minTeams'],
        'registrationOpens': value['registrationOpens'],
        'registrationCloses': value['registrationCloses'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
        'status': TournamentStatusToJSON(value['status']),
        'entryType': CompetitionEntryTypeToJSON(value['entryType']),
        'entryFeeConfig': EntryFeeConfigResponseToJSON(value['entryFeeConfig']),
        'entryFee': value['entryFee'],
        'entryFeeCurrency': TournamentCurrencyToJSON(value['entryFeeCurrency']),
        'entryFeeUnit': EntryFeeUnitToJSON(value['entryFeeUnit']),
        'feeMode': TournamentFeeModeToJSON(value['feeMode']),
        'allowedFeeModes': value['allowedFeeModes'] == null ? undefined : ((value['allowedFeeModes'] as Array<any>).map(TournamentFeeModeToJSON)),
        'prizeSplit': TournamentPrizeSplitToJSON(value['prizeSplit']),
        'prizePool': TournamentPrizePoolToJSON(value['prizePool']),
        'payoutTableId': value['payoutTableId'],
        'minParticipants': value['minParticipants'],
        'collectedPrizePool': value['collectedPrizePool'],
        'bracket': TournamentBracketToJSON(value['bracket']),
        'registeredTeams': value['registeredTeams'],
        'registeredTeamsCount': value['registeredTeamsCount'],
        'finalStandings': value['finalStandings'] == null ? undefined : ((value['finalStandings'] as Array<any>).map(TournamentFinalStandingToJSON)),
        'createdBy': value['createdBy'],
        'sponsorId': value['sponsorId'],
        'sponsorThemeColors': ChallengeThemeColorsToJSON(value['sponsorThemeColors']),
        'platform': TournamentPlatformToJSON(value['platform']),
        'region': TournamentRegionToJSON(value['region']),
        'privacy': TournamentPrivacyToJSON(value['privacy']),
        'skillLevel': TournamentSkillLevelToJSON(value['skillLevel']),
        'ageRestriction': value['ageRestriction'],
        'checkInRequired': value['checkInRequired'],
        'checkInWindowMinutes': value['checkInWindowMinutes'],
        'streamUrl': value['streamUrl'],
        'discordUrl': value['discordUrl'],
        'contactEmail': value['contactEmail'],
        'imageUrl': value['imageUrl'],
        'chatChannelId': value['chatChannelId'],
        'category': TournamentCategoryToJSON(value['category']),
        'rosterLocked': value['rosterLocked'],
        'rosterLockedAt': value['rosterLockedAt'],
        'rosterLockedBy': value['rosterLockedBy'],
        'hasPassword': value['hasPassword'],
        'bestOf': value['bestOf'],
        'isRecurring': value['isRecurring'],
        'recurringSchedule': value['recurringSchedule'],
        'recurringTimezone': value['recurringTimezone'],
        'parentTournamentId': value['parentTournamentId'],
        'recurringInstanceNumber': value['recurringInstanceNumber'],
        'competitionId': value['competitionId'],
        'ruleSetId': value['ruleSetId'],
        'advancementRules': TournamentAdvancementRulesToJSON(value['advancementRules']),
        'clanTagRequired': value['clanTagRequired'],
        'clanTagFormat': value['clanTagFormat'],
        'matchModeId': value['matchModeId'],
        'subModeId': value['subModeId'],
        'scoringTemplateId': value['scoringTemplateId'],
        'scoringMode': value['scoringMode'],
        'bracketTemplateId': value['bracketTemplateId'],
        'sharedBracketId': value['sharedBracketId'],
        'lateRegistrationMinutes': value['lateRegistrationMinutes'],
        'featured': value['featured'],
        'featuredUntil': value['featuredUntil'],
        'skipConsolationRound': value['skipConsolationRound'],
        'skipGrandFinalComeback': value['skipGrandFinalComeback'],
        'skipSecondaryFinal': value['skipSecondaryFinal'],
        'customPrizeLabels': value['customPrizeLabels'],
        'platforms': value['platforms'] == null ? undefined : ((value['platforms'] as Array<any>).map(TournamentPlatformToJSON)),
        'regions': value['regions'] == null ? undefined : ((value['regions'] as Array<any>).map(TournamentRegionToJSON)),
        'antiCheat': value['antiCheat'],
        'eligibility': value['eligibility'],
        'ruleset': value['ruleset'],
        'rulesUrl': value['rulesUrl'],
        'platformNotes': value['platformNotes'],
        'cancelledAt': value['cancelledAt'],
        'cancelledBy': value['cancelledBy'],
        'cancellationReason': value['cancellationReason'],
        'archivedAt': value['archivedAt'],
        'archivedBy': value['archivedBy'],
        'emergencyFrozen': value['emergencyFrozen'],
        'emergencyFrozenAt': value['emergencyFrozenAt'],
        'emergencyFrozenBy': value['emergencyFrozenBy'],
        'emergencyFreezeReason': value['emergencyFreezeReason'],
        'autoStartEnabled': value['autoStartEnabled'],
        'faqs': value['faqs'] == null ? undefined : ((value['faqs'] as Array<any>).map(CompetitionFaqToJSON)),
        'prerequisites': ((value['prerequisites'] as Array<any>).map(PrerequisiteResponseToJSON)),
        'appliedFilterIds': value['appliedFilterIds'],
        'excludedGlobalFilters': value['excludedGlobalFilters'] == null ? undefined : ((value['excludedGlobalFilters'] as Array<any>).map(GlobalFilterExclusionToJSON)),
        'failOpenOnMissingContext': value['failOpenOnMissingContext'],
        'requireActiveMatch': value['requireActiveMatch'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'teams': value['teams'] == null ? undefined : ((value['teams'] as Array<any>).map(TournamentTeamSummaryToJSON)),
        'matches': value['matches'] == null ? undefined : ((value['matches'] as Array<any>).map(MatchResponseToJSON)),
        'userTeamId': value['userTeamId'],
    };
}

